<template>
	<div id="app">
		<div
			v-if="
				(authUser &&
					(authUser.email.includes('srdjan') ||
						authUser.email.includes('jerrica') ||
						authUser.email.includes('marta') ||
						authUser.email.includes('aleksandra') ||
						authUser.email.includes('ivan') ||
						authUser.email.includes('flor') ||
						authUser.email.includes('francine') ||
					authUser.email.includes('jelena') ||
					authUser.email.includes('ana') ||
					authUser.email.includes('vanja') ||
					authUser.email.includes('peter')))
			"
			:class="{ 'tt-wrapper--open': ttOpen }"
			class="tt-wrapper"
		>
			<div class="tt-info">
				<div class="d-flex justify-content-start align-items-center">
					<ClientSelector :key="csKey" :selected="timingClient" v-on:setClient="setClient" />
					<div v-if="!timingClient" class="btn-group">
						<button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
							<font-awesome-icon :icon="['fas', 'bookmark']" />
						</button>
						<ul class="dropdown-menu">
							<li :key="fClient.id" v-for="fClient in favoriteClients">
								<a class="dropdown-item dropdown-item-small cursor-pointer" @click="setClient(fClient)">{{ fClient.name }}</a>
							</li>
						</ul>
					</div>
					<button class="btn btn-sm" v-if="timingClient != null && inFavorites" @click="removeClientFromFavorites()">
						<font-awesome-icon :icon="['fas', 'bookmark']" />
					</button>
					<button class="btn btn-sm" v-if="timingClient != null && !inFavorites" @click="addClientToFavorites()">
						<font-awesome-icon :icon="['far', 'bookmark']" />
					</button>
				</div>
				<div>
					<div v-if="timingClient" class="d-flex justify-content-center align-items-center">
						<span class="me-2">Track</span>
						<div class="form-check form-switch align-items-center d-flex mb-1">
							<input class="form-check-input me-2" v-model="startTiming" type="checkbox" role="switch" />
							<div class="blinking-dot" :class="{ start: startTiming }"></div>
						</div>
						<div class="tt-timer" v-if="startTiming">
							<font-awesome-icon :icon="['fas', 'stopwatch']" class="me-1" />
							<span>{{ formattedElapsed }}</span>
						</div>
					</div>
				</div>
			</div>
			<button @click="openTTelement()" class="tt-button">
				<div :class="{ 'tt-button-dot': startTiming }"></div>
				<font-awesome-icon :icon="['fas', 'stopwatch']" />
			</button>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
import ClientSelector from './components/clients/ClientSelector.vue'
import { mapGetters, mapState } from 'vuex'
import restApi from './api/index'
export default {
	name: 'App',
	data() {
		return {
			startTiming: localStorage.getItem('startTiming') == 'true' ? true : false,
			timingClient: JSON.parse(localStorage.getItem('timingClient')) || null,
			favoriteClients: JSON.parse(localStorage.getItem('favoriteClients')) || [],
			inFavorites: true,
			csKey: 0,
			ttOpen: false,
			timingStartedAt: localStorage.getItem('timingStartedAt') ? Number(localStorage.getItem('timingStartedAt')) : null,
			elapsedSeconds: 0,
			timerInterval: null,
		}
	},
	components: { ClientSelector },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),

		currentRoute() {
			return this.$route.path
		},
		formattedElapsed() {
			const total = this.elapsedSeconds || 0
			const hours = String(Math.floor(total / 3600)).padStart(2, '0')
			const minutes = String(Math.floor((total % 3600) / 60)).padStart(2, '0')
			const seconds = String(total % 60).padStart(2, '0')
			return `${hours}:${minutes}:${seconds}`
		},
	},
	watch: {
		startTiming(newValue) {
			if (newValue) {
				this.startTimer()
			} else {
				this.stopTimer()
			}
		},
		timingClient(newValue, oldValue) {
			if (newValue == null) {
				this.stopTimer(oldValue)
			}

			if (newValue == null) {
				this.inFavorites = false
				return
			}

			let isFavorite = this.favoriteClients.find(client => client.id == this.timingClient.id)

			if (isFavorite) {
				this.inFavorites = true
			} else {
				this.inFavorites = false
			}
		},
		favoriteClients: {
			handler(newArray) {
				let isFavorite = newArray.find(client => client.id == this.timingClient.id)

				if (isFavorite) {
					this.inFavorites = true
				} else {
					this.inFavorites = false
				}
			},
			deep: true,
		},
	},
	beforeDestroy() {
		this.stopLocalTimer()
	},
	created() {
		let isFavorite = this.favoriteClients.find(client => client.id == this.timingClient.id)

		if (isFavorite) {
			this.inFavorites = true
		} else {
			this.inFavorites = false
		}

		if (this.startTiming && this.timingStartedAt) {
			this.startLocalTimer()
		}
	},
	methods: {
		openTTelement() {
			this.ttOpen = !this.ttOpen
		},
		setClient(client) {
			this.csKey++
			this.timingClient = client
			localStorage.setItem('timingClient', JSON.stringify(this.timingClient))
		},
		startTimer() {
			localStorage.setItem('startTiming', this.startTiming)
			this.timingStartedAt = Date.now()
			localStorage.setItem('timingStartedAt', String(this.timingStartedAt))
			this.startLocalTimer()
			let preparedData = {
				key: 'TT-' + this.generateRandom(64),
				watcher: 'mc2',
				user_id: this.authUser.id,
				user_email: this.authUser.email,
				client_id: this.timingClient.id,
				client_name: this.timingClient.name,
			}
			this.storeTimeTrack(preparedData)
		},
		stopTimer(client = null) {
			this.startTiming = false
			this.stopLocalTimer()
			localStorage.removeItem('timingStartedAt')
			this.timingStartedAt = null
			if (!client) {
				let startedKey = localStorage.getItem('timingSession')
				let preparedData = {
					key: startedKey,
				}
				this.updateTimeTrack(preparedData)
			}
			// Unset start timing
			localStorage.setItem('startTiming', this.startTiming)
		},

		storeTimeTrack(object) {
			restApi
				.post(`/time-track`, object)
				.then(({ data }) => {
					localStorage.setItem('timingSession', data.key)
				})
				.catch(error => {
					console.error(error)
				})
		},

		updateTimeTrack(data) {
			restApi
				.post(`/time-track/finish`, data)
				.then(() => {
					localStorage.removeItem('timingSession')
				})
				.catch(error => {
					console.error(error)
				})
		},
		startLocalTimer() {
			if (this.timerInterval) {
				clearInterval(this.timerInterval)
			}
			const updateElapsed = () => {
				if (!this.timingStartedAt) {
					this.elapsedSeconds = 0
					return
				}
				const diff = Math.floor((Date.now() - this.timingStartedAt) / 1000)
				this.elapsedSeconds = diff > 0 ? diff : 0
			}
			updateElapsed()
			this.timerInterval = setInterval(updateElapsed, 1000)
		},
		stopLocalTimer() {
			if (this.timerInterval) {
				clearInterval(this.timerInterval)
				this.timerInterval = null
			}
			this.elapsedSeconds = 0
		},

		generateRandom(length) {
			let result = ''
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			const charactersLength = characters.length
			for (let i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength))
			}
			return result
		},

		addClientToFavorites() {
			//Check is client already in favorites
			if (this.timingClient && this.timingClient.id) {
				let isFavorite = this.favoriteClients.find(client => client.id == this.timingClient.id)
				if (isFavorite) {
					return
				}
				this.favoriteClients.push(this.timingClient)
				localStorage.setItem('favoriteClients', JSON.stringify(this.favoriteClients))
			}
		},

		removeClientFromFavorites() {
			this.favoriteClients = this.favoriteClients.filter(favClient => favClient.id != this.timingClient.id)
			localStorage.setItem('favoriteClients', JSON.stringify(this.favoriteClients))
		},

		selectClientFromFavorites(client) {
			this.timingClient = client
			localStorage.setItem('timingClient', JSON.stringify(this.timingClient))
		},
	},
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400;600;800&display=swap');
@import '../src/assets/sass/design';

#app {
	display: flex;
	background-color: #f8f8f8;
}
.col-content {
	min-height: 100vh;
}

@media (max-width: 575.98px) {
	.col-sidebar {
		width: 0 !important;
		max-width: 0 !important;
		padding: 0 !important;
		margin: 0 !important;
	}
}
</style>
